const data = {
  state: {
      skip: 0,
      take: 10,
      filter: {
          logic: 'and' as 'and',
          filters: []
      },
      group: []
  },
  columnsConfig: [
    {
      field: 'statut',
      title: 'Statut'
    },
    {
      field: 'code',
      title: 'Référence'
    },
    {
      field: 'dateReception',
      title: 'Date de réception'
    },
    {
      field: 'dateValiditeFinOffre',
      title: 'Fin de validité'
    },
    {
      field: 'prix',
      title: 'Prix (€)'
    },
    {
      field: 'docGenerated',
      title: ''
    }
  ]
};

export default data;